class BrandCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.brand-carousel-track');
    this.content = container.querySelector('.brand-carousel-content');
    this.prevButton = container.querySelector('.carousel-prev');
    this.nextButton = container.querySelector('.carousel-next');
    this.playPauseButton = container.querySelector('.carousel-play-pause');
    
    // Configuration
    this.autoScroll = container.dataset.autoScroll === 'true';
    this.scrollSpeed = parseInt(container.dataset.scrollSpeed, 10) || 20;
    this.scrollDirection = 1; // 1 = forward, -1 = backward
    this.isPaused = false; // Fixed: Always start unpaused when autoScroll is true
    this.manuallyPaused = false; // Add it here, after isPaused
    this.isTransitioning = false;

    // Animation properties
    this.animationId = null;
    this.lastTimestamp = 0;
    this.scrollPosition = 0;
    this.contentWidth = 0;
    
    // Initialization
    this.init();
  }
  
  init() {
    // Set initial button state
    this.updatePlayPauseButton();
    
    // Ensure horizontal layout
    this.ensureHorizontalLayout();
    
    // Calculate dimensions
    this.calculateDimensions();
    
    // Event listeners
    this.prevButton.addEventListener('click', () => this.scroll(-1, true));
    this.nextButton.addEventListener('click', () => this.scroll(1, true));
    this.playPauseButton.addEventListener('click', () => this.togglePlayPause());
    
    window.addEventListener('resize', this.debounce(() => {
      this.ensureHorizontalLayout();
      this.calculateDimensions();
      this.resetPosition();
    }, 250));
    
    // Start animation if auto-scroll is enabled
    if (this.autoScroll) {
      this.startAnimation();
    }
    
    // Pause on hover (optional)
  this.container.addEventListener('mouseenter', () => {
  // Only pause temporarily if we're not already manually paused
  if (!this.isPaused && !this.manuallyPaused) {
    this.tempPause = true;
    this.pause(false);
    }
  });

  this.container.addEventListener('mouseleave', () => {
  // Only resume if we were temporarily paused, not manually paused
  if (this.tempPause && !this.manuallyPaused) {
    this.tempPause = false;
    this.play(false);
    }
  });
  }

  ensureHorizontalLayout() {
    // Force horizontal layout
    this.track.style.display = 'flex';
    this.track.style.flexDirection = 'row';
    this.track.style.flexWrap = 'nowrap';
    
    const contents = this.track.querySelectorAll('.brand-carousel-content');
    contents.forEach(content => {
      content.style.display = 'flex';
      content.style.flexDirection = 'row';
      content.style.flexWrap = 'nowrap';
      content.style.width = 'max-content';
      
      // Force all logo items to be side by side
      const items = content.querySelectorAll('.brand-logo-item');
      items.forEach(item => {
        item.style.display = 'flex';
        item.style.float = 'left';

        // Get the logo height from style attribute
        const logoHeight = item.style.height;
        if (logoHeight) {
          // Apply the same height and width to make it square
          const heightValue = parseInt(logoHeight);
          if (!isNaN(heightValue)) {
            item.style.width = `${heightValue}px`;
            item.style.minWidth = `${heightValue}px`;
            
            // Also set max dimensions for the image inside
            const image = item.querySelector('.brand-logo-image');
            if (image) {
              image.style.maxHeight = `${heightValue}px`;
              image.style.maxWidth = `${heightValue}px`;
            }
            
            // Update placeholder if present
            const placeholder = item.querySelector('.brand-logo-placeholder');
            if (placeholder) {
              placeholder.style.height = `${heightValue}px`;
              placeholder.style.width = `${heightValue}px`;
            }
          }
        }
      });
    });
  }
  
  calculateDimensions() {
    // Get content width
    this.contentWidth = this.content.offsetWidth;
    
    // Make sure clone is positioned correctly
    const clone = this.track.querySelector('.clone');
    if (clone) {
      const items = this.content.querySelectorAll('.brand-logo-item');
      const cloneItems = clone.querySelectorAll('.brand-logo-item');
      
      // Remove any visual separation between original and cloned items
      const lastOriginalItem = items[items.length - 1];
      if (lastOriginalItem) {
        lastOriginalItem.style.marginRight = '15px'; // Keep consistent with other items
      }
      
      // Ensure same dimensions for all items
      if (items.length === cloneItems.length) {
        items.forEach((item, index) => {
          const itemWidth = item.offsetWidth;
          cloneItems[index].style.width = `${itemWidth}px`;
          
          // Make sure all items have the same margin
          item.style.margin = '0 15px';
          cloneItems[index].style.margin = '0 15px';
        });
      }
      
      // Position clone immediately after original
      clone.style.left = `${this.contentWidth}px`;
    }
  }
  
  startAnimation() {
    // Only start if not already running
    if (!this.animationId) {
      this.lastTimestamp = 0; // Reset timestamp for smooth starting
      this.animationId = window.requestAnimationFrame(this.animate.bind(this));
    }
  }
  
  stopAnimation() {
    if (this.animationId) {
      window.cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }
  
  animate(timestamp) {
    // Exit early if paused - this is critical for proper pausing
    if (this.isPaused) {
      this.animationId = null;
      return;
    }
    
    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp;
    }
    
    const elapsed = timestamp - this.lastTimestamp;
    
    if (elapsed > 16) { // Approx 60fps
      // Calculate how much to move
      const pixelsToMove = (elapsed * this.scrollSpeed) / 1000;
      this.scrollPosition += pixelsToMove * this.scrollDirection;
      
      // Reset position when a full loop is completed
      if (Math.abs(this.scrollPosition) >= this.contentWidth) {
        this.scrollPosition = 0;
      }
      
      // Apply transform
      this.track.style.transform = `translateX(${-this.scrollPosition}px)`;
      this.lastTimestamp = timestamp;
    }
    
    // Only request next frame if not paused
    if (!this.isPaused) {
      this.animationId = window.requestAnimationFrame(this.animate.bind(this));
    }
  }
  
    scroll(direction, manual = false) {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.scrollDirection = direction;
    
    // If manual scroll and animation is running, temporarily stop it
    let wasRunning = false;
    if (manual && !this.isPaused) {
      wasRunning = true;
      this.stopAnimation();
    }

    
    // Add class to prevent animation during calculation
    this.track.classList.add('no-animation');
    
    // Calculate scroll amount (about 25% of visible width)
    const scrollAmount = this.container.offsetWidth * 0.25;
    const currentPosition = this.scrollPosition;
    let targetPosition = currentPosition + (scrollAmount * direction);
    
    // Reset position if needed
    if (targetPosition > this.contentWidth) {
      this.scrollPosition = 0;
      targetPosition = scrollAmount;
    } else if (targetPosition < 0) {
      this.scrollPosition = this.contentWidth;
      targetPosition = this.contentWidth - scrollAmount;
    }
    
    // Force reflow
    void this.track.offsetWidth;
    
    // Remove no-animation class and set transition
    this.track.classList.remove('no-animation');
    this.track.style.transition = 'transform 500ms ease-out';
    this.track.style.transform = `translateX(${-targetPosition}px)`;
    
    // Update scroll position after animation
    setTimeout(() => {
      this.scrollPosition = targetPosition;
      this.track.style.transition = '';
      this.isTransitioning = false;
    }, 500);
  }
  
  togglePlayPause() {
    if (this.isPaused) {
      this.manuallyPaused = false;
      this.play(true);
    } else {
      this.manuallyPaused = true;
      this.pause(true);
    }
  }
  
  play(updateButton = true) {
    // Only change state if currently paused
    if (this.isPaused) {
      this.isPaused = false;
      this.startAnimation();
      if (updateButton) {
        this.updatePlayPauseButton();
        this.track.classList.remove('paused');
      }
    }
  }
  
  pause(updateButton = true) {
    // Only change state if currently playing
    if (!this.isPaused) {
      this.isPaused = true;
      this.stopAnimation();
      if (updateButton) {
        this.updatePlayPauseButton();
        this.track.classList.add('paused');
      }
    }
  }
  
  updatePlayPauseButton() {
    this.playPauseButton.setAttribute('aria-pressed', this.isPaused);
    // Add is-paused class to support both styling approaches
    this.playPauseButton.classList.toggle('is-paused', this.isPaused);
    
    if (this.isPaused) {
      this.playPauseButton.setAttribute('aria-label', 'Play');
    } else {
      this.playPauseButton.setAttribute('aria-label', 'Pause');
    }
  }
  
  resetPosition() {
    this.track.style.transition = 'none';
    this.scrollPosition = 0;
    this.track.style.transform = 'translateX(0)';
    
    // Force reflow
    void this.track.offsetWidth;
    
    // Restore transition
    this.track.style.transition = '';
  }
  
  // Utility methods
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

// Initialize all carousels when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[id^="brand-carousel-"]');
  carousels.forEach(carousel => new BrandCarousel(carousel));
});

// For Shopify section rendering events
document.addEventListener('shopify:section:load', (event) => {
  const carousel = event.target.querySelector('[id^="brand-carousel-"]');
  if (carousel) {
    new BrandCarousel(carousel);
  }
});

// Add this to the end of your brand-carousel.js file
// This helps synchronize multiple carousels on the same page

// Find connected carousels and synchronize their behavior
document.addEventListener('DOMContentLoaded', () => {
  // Wait for all carousels to initialize
  setTimeout(() => {
    const connectedCarousels = document.querySelectorAll('.connected-carousel');
    
    connectedCarousels.forEach(carousel => {
      const currentCarouselId = carousel.id;
      const nextCarousel = carousel.nextElementSibling;
      
      if (nextCarousel && nextCarousel.classList.contains('section-brand-carousel')) {
        // Match the scroll speeds
        const currentSpeed = carousel.dataset.scrollSpeed;
        nextCarousel.dataset.scrollSpeed = currentSpeed;
        
        // Ensure both scroll in the same direction
        const currentInstance = findCarouselInstance(currentCarouselId);
        const nextInstance = findCarouselInstance(nextCarousel.id);
        
        if (currentInstance && nextInstance) {
          // Sync scroll direction
          nextInstance.scrollDirection = currentInstance.scrollDirection;
          
          // Sync play/pause state
          if (currentInstance.isPaused) {
            nextInstance.pause(true);
          } else {
            nextInstance.play(true);
          }
          
          // Add event listeners to keep them synchronized
          carousel.querySelector('.carousel-play-pause').addEventListener('click', () => {
            setTimeout(() => {
              if (currentInstance.isPaused) {
                nextInstance.pause(true);
              } else {
                nextInstance.play(true);
              }
            }, 50);
          });
        }
      }
    });
  }, 500); // Wait for carousels to initialize
});

// Helper function to find carousel instance by container ID
function findCarouselInstance(containerId) {
  // This function works if carouselInstances array exists
  if (typeof window.carouselInstances === 'undefined') {
    return null;
  }
  
  return window.carouselInstances.find(instance => instance.container.id === containerId);
}

// Modify BrandCarousel constructor to store instances
const originalBrandCarousel = BrandCarousel;
window.carouselInstances = [];

BrandCarousel = function(container) {
  const instance = new originalBrandCarousel(container);
  window.carouselInstances.push(instance);
  return instance;
};

BrandCarousel.prototype = originalBrandCarousel.prototype;

